import Vue from "vue";
import { Component } from "vue-property-decorator";
import LogisticLoadRestModel from "../../models/rest/logistic/logisticLoadRestModel";
import LogisticLoadBidRestModel from "../../models/rest/logistic/logisticLoadBidRestModel";

@Component({
    props: {
        currentInfoWindow: {},
    },
})

export default class LogisticLoadInfoWindow extends Vue {
    currentInfoWindow!: any;
    offeredPriceCurrency = "EUR";
    logisticLoadBid = {
        offeredPriceCurrency: this.offeredPriceCurrency,
    } as LogisticLoadBidRestModel;

    get logisticLoad(): LogisticLoadRestModel {
        return this.$store.direct.state.logistic.logisticLoad;
    }

    get currentUserContractorId(): number {
        return this.$store.direct.state.auth.currentUserContractorId;
    }

    allowNumbersOnly(evt: any) {
        return this.$store.direct.dispatch.settlementCommon.allowNumbersOnly(evt);
    }

    closeInfoWindowClick() {
        this.currentInfoWindow.close();
    }

    async sendBid() {
        const form = this.$refs.form as Vue & { validate: () => boolean };

        if (!form.validate()) {
            return;
        }

        this.logisticLoadBid.loadId = this.logisticLoad.id;
        this.logisticLoadBid.carrierId = this.currentUserContractorId;

        await this.$store.direct.dispatch.logistic.sendBid({ logisticLoadBid: this.logisticLoadBid });
        this.logisticLoadBid = {
            offeredPriceCurrency: this.offeredPriceCurrency,
        } as LogisticLoadBidRestModel;
    }
}